import { useCallback } from 'react';
import { TMapOffersResult } from 'shared/types/common/offer';
import { getOffersCount } from 'shared/utils/offers/flattenOffersList';
import { scrollToOffersListing } from 'shared/utils/scroll';
import { useTracking } from 'shared/utils/tracking/useTracking';

export const useScrollToOffers = (offersList: TMapOffersResult) => {
  const { trackMobileShowButtonAmountOffers } = useTracking();
  const offersCount = getOffersCount(offersList);

  return useCallback(() => {
    scrollToOffersListing({ isDesktop: false });
    trackMobileShowButtonAmountOffers(offersCount);
  }, [offersCount, trackMobileShowButtonAmountOffers]);
};
